const borderWidthScale = [0, 1, 2, 3, 4, 5, 6] as const;

const borderRadiusScale = [
  'none',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl',
  '3xl',
  'full',
] as const;

type BorderWidthScale = (typeof borderWidthScale)[number];
type BorderRadiusScale = (typeof borderRadiusScale)[number];

function generateBorderWidthVariants(prefix: string) {
  return borderWidthScale.reduce(
    (acc, value) => {
      if (value === 1) {
        acc[value] = prefix;
      } else {
        acc[value] = `${prefix}-${value}`;
      }
      return acc;
    },
    {} as Record<BorderWidthScale, string>,
  );
}

function generateBorderRadiusVariants(prefix: string) {
  return borderRadiusScale.reduce(
    (acc, value) => {
      acc[value] = `${prefix}-${value}`;
      return acc;
    },
    {} as Record<BorderRadiusScale, string>,
  );
}

const borderVariants = {
  border: generateBorderWidthVariants('border'),
  borderTop: generateBorderWidthVariants('border-t'),
  borderRight: generateBorderWidthVariants('border-r'),
  borderBottom: generateBorderWidthVariants('border-b'),
  borderLeft: generateBorderWidthVariants('border-l'),
  borderX: generateBorderWidthVariants('border-x'),
  borderY: generateBorderWidthVariants('border-y'),
  rounded: generateBorderRadiusVariants('rounded'),
  roundedTop: generateBorderRadiusVariants('rounded-t'),
  roundedRight: generateBorderRadiusVariants('rounded-r'),
  roundedBottom: generateBorderRadiusVariants('rounded-b'),
  roundedLeft: generateBorderRadiusVariants('rounded-l'),
  roundedTopLeft: generateBorderRadiusVariants('rounded-tl'),
  roundedTopRight: generateBorderRadiusVariants('rounded-tr'),
  roundedBottomRight: generateBorderRadiusVariants('rounded-br'),
  roundedBottomLeft: generateBorderRadiusVariants('rounded-bl'),
} as const;

type BorderVariants = typeof borderVariants;

export {
  type BorderRadiusScale,
  type BorderVariants,
  borderVariants,
  type BorderWidthScale,
};
